module.exports = __webpack_public_path__ + "img/small-book.9b26ead.svg";